import React, { useMemo } from "react";
import BaseNode from "./BaseNode";
import { LinkIcon, MessageSquareIcon } from "lucide-react";
import { Position } from "@xyflow/react";
import { HandleProps, NodeProps } from "./types";
import FormField from "../FormField";
import { Input } from "../ui/input";

export default function UrlLoaderNode(props: NodeProps) {
  const handles: HandleProps[] = useMemo(
    () => [
      {
        type: "source",
        position: Position.Right,
        id: "output",
        label: "output",
      },
      {
        type: "target",
        position: Position.Left,
        id: "url",
        label: "url",
      },
    ],
    [],
  );
  return (
    <BaseNode
      title="URL Loader"
      icon={<LinkIcon size={16} />}
      handles={handles}
      {...props}
    >
      <FormField label="URL" caption="Reads data from a URL">
        <Input name="url" />
      </FormField>
    </BaseNode>
  );
}
